/*
 * Copyright (c) 2026. Bluemate B.V.
 */

import IDate from '@dvrd/idate';

import ProductReview from '../../../models/productReviewModel';

import {ISO_DATE_FORMAT} from '../../../util/constants';

export type ReviewDateGroup = {
    /** Stable, locale-independent day key (YYYY-MM-DD) — use as React key. */
    key: string;
    /** Representative date of the group — format this for the group label. */
    date: IDate;
    reviews: Array<ProductReview>;
};

/** Groups a (date-descending) review feed into per-day buckets, preserving the
 *  feed order of both the days and the reviews within each day. */
export function groupReviewsByDate(reviews: Array<ProductReview>): Array<ReviewDateGroup> {
    const groups = new Map<string, ReviewDateGroup>();
    for (const review of reviews) {
        const date = review.reviewDate;
        const key = date.format(ISO_DATE_FORMAT);
        const existing = groups.get(key);
        if (existing) existing.reviews.push(review);
        else groups.set(key, {key, date, reviews: [review]});
    }
    return Array.from(groups.values());
}
